import { EventEmitter, Injectable } from '@angular/core';
import {
  BaseFpxComponentState,
  BaseFpxFormHelper,
  HttpProviderService,
  IHttpSuccessPayload,
  RoutingInfo,
  BaseFpxChangeHandler,
  BaseFpxControlEventHandler,
  HttpRequest,
  SpinnerService,
  ILookupResponse,
  CriteriaQuery,
} from "@fpx/core";
import { BehaviorSubject, Observable, map, of } from "rxjs";
import { CommonService } from 'src/app/common.service';
import { FileOpenerService } from 'src/app/services/mobile/file-opener.service';
import { environment } from "src/environments/environment";


@Injectable({
  providedIn: 'root'
})
export class MailBoxMainService {
  isCaseEmptyEmit: EventEmitter<any>;

  constructor(private _fileOpener: FileOpenerService, private _commonService: CommonService, private _httpProvider: HttpProviderService){}




  getFileName(invNumber: any): Observable<any> {
    const httpRequest = new HttpRequest();
    httpRequest.setMethod('GET');
    httpRequest.setResource('/documentdownload/{inventoryNumber}');
    httpRequest.addPathParameter('inventoryNumber', invNumber);
    httpRequest.addQueryParameter('documentType', "PASSPORT");
    httpRequest.setServerContext(environment.commonPublisher);
    return this._httpProvider.invokeDownloadApi(httpRequest);
  }


  downloadFile(inventoryNumber) {

    const httpRequest = new HttpRequest();
    httpRequest.setMethod('GET');
    httpRequest.setResource('/documentdownload/{inventoryNumber}');
    httpRequest.addPathParameter('inventoryNumber', inventoryNumber);
    httpRequest.addQueryParameter('documentType', "PASSPORT");
    httpRequest.setServerContext(environment.commonPublisher);
    this._httpProvider.invokeDownloadApi(httpRequest).pipe(
    ).subscribe({
      next: (response: any) => {
        this._commonService.hideSpinner();
        let fileName = this._commonService.decodeFileName(response);
        let fileType = fileName ? fileName.split('.') : undefined;
        let mimeType = this._commonService.getFileMimeType(fileType ? fileType?.[fileType?.length - 1] : 'pdf');
        if (this._commonService.isHybrid()) {
          this._fileOpener.openPDF(response, mimeType, fileName);
        }
        else {
          let documentURL = URL.createObjectURL(new Blob([response.body], { type: mimeType }));
          const downloadLink = document.createElement("a");
          downloadLink.href = documentURL;
          downloadLink.download = fileName;
          downloadLink.click();
        }
      },
    })
  }


  getMailLength() {
    const httpRequest = new HttpRequest();
    httpRequest.setResource('/caseRetailUsers');
    httpRequest.setMethod('GET');
    return this._httpProvider.invokeRestApi(httpRequest).pipe(
      map(
        (res: IHttpSuccessPayload<any>) => {
          return res?.body?.case
        }
      )
    ).subscribe(res => {
      this.setNewMailCount(res);
    });

}

setNewMailCount(payload){
  let newMilCount = 0
  if(payload && payload.length>0){
    payload.forEach(x=>{
      if(x.isNew == "1"){
        ++newMilCount;
      }
    })
    this._commonService.newMails = newMilCount
  }else{
    this._commonService.newMails = 0
  }
}


}
